import { FileUp, Loader2, Sparkles } from "lucide-react";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getTitleForPath } from "../nav-config";

export default function InnovationWorkbench() {
  const { pathname } = useLocation();
  const title = useMemo(() => getTitleForPath(pathname), [pathname]);

  return (
    <div className="min-h-full pb-16">
      <div className="mb-6 rounded-2xl border border-border bg-card p-5 shadow-sm">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">Workbench</p>
            <h1 className="mt-2 text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">
              国家重大科技项目与机构内评普遍要求：指标可拆分、结论可复核、过程可归档。以下为与「{title}」对齐的评审作业台（演示原型），上传材料后即可生成结构化卡片与综合报告草稿。
            </p>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:opacity-90"
          >
            <Sparkles className="h-4 w-4" />
            运行智能分析
          </button>
        </div>
      </div>

      <div className="space-y-6">
        <section className="rounded-2xl border border-dashed border-border bg-card p-8 text-center shadow-sm">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-muted text-primary">
            <FileUp className="h-7 w-7" />
          </div>
          <h2 className="mt-5 text-lg font-semibold text-foreground">上传材料或粘贴正文</h2>
          <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">支持 PDF / Word / 文本片段；评审维度与本页标题对齐。</p>
          <button
            type="button"
            className="mt-6 inline-flex items-center gap-2 rounded-xl border border-border bg-muted/60 px-5 py-2.5 text-sm font-medium text-foreground hover:bg-muted"
          >
            <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
            演示模式 · 尚未接入后端
          </button>
        </section>

        <section className="grid gap-4 md:grid-cols-3">
          {["结构化抽取", "对标检索", "结论草稿"].map((step, i) => (
            <div key={step} className="rounded-2xl border border-border bg-card p-5 shadow-sm">
              <div className="mb-3 flex h-8 w-8 items-center justify-center rounded-lg bg-muted text-xs font-bold text-muted-foreground">{i + 1}</div>
              <div className="font-semibold text-foreground">{step}</div>
              <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
                {i === 0 && "抽取图表目录、经费科目与创新点表述。"}
                {i === 1 && "对齐同类立项与高水平论文可比口径。"}
                {i === 2 && "生成管理层可读的综合段落与风险提示。"}
              </p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
